// Static routes to run the app. Only use one: local or heroku.
//export const API_ENDPOINT = 'http://localhost:8080/api/';
export const API_ENDPOINT = 'https://amrnetstaging-4f7a1b5cd3f3.herokuapp.com/api/';
